import { LocalizableEntryWithLang } from '@app/models'

import { DEFAULT_LANGUAGE } from '@app/utils/regional'

export const getTranslatedData = (
  dataList: LocalizableEntryWithLang[],
  lang: string = ''
): string => {
  if (!dataList || !dataList.length) return ''

  let translatedData = dataList.find(
    (x) => x.language != null && x.language.toLowerCase() == lang
  )
  if (!translatedData) {
    translatedData = dataList.find(
      (x) => x.language != null && x.language.toLowerCase() == DEFAULT_LANGUAGE
    )
  }
  if (!translatedData) {
    translatedData = dataList[0]
  }
  return (translatedData && translatedData.text) || ''
}
